import {
    Button,
    HStack,
    IconButton,
    Link,
    Stack,
    Tooltip,
    useClipboard,
    VStack,
  } from "@chakra-ui/react";
  import React from "react";
//   import { Typewriter } from "react-simple-typewriter";
  import { MdPhone, MdEmail, MdLocationOn } from "react-icons/md";
  import { BsGithub, BsLinkedin } from "react-icons/bs";
  import { SiDiscord } from "react-icons/si";
  
  export const SocialMedia = () => {
    const { hasCopied, onCopy } = useClipboard("chinthasiva872@gmail.com");
    return (
      <div id="contact" style={{ background: "linear-gradient(180deg, rgba(0, 212, 255, 1) 100%, rgba(90, 185, 215, 1) 58%, rgba(114, 219, 241, 1) 0%)",paddingTop:"20px"}}>
        <VStack>
          {/* <Heading
            size={{ base: "md", md: "xl" }}
            style={{ padding: "1rem", margin: "auto 0", fontWeight: "normal" }}
          >
            Let's{" "}
            <span style={{ color: "red", fontWeight: "bold" }}>
            </span>
          </Heading>
  
          <Heading size={{ base: "lg", md: "xl" }}>Connect with me:</Heading> */}
          <HStack
            mt={{ lg: 10, md: 10 }}
            spacing={5}
            px={5}
            alignItems="flex-start"
          >
            <Link
              id="contact-github"
              href="https://github.com/chintasiva"
              target={"_blank"}
            >
              <IconButton
                aria-label="github"
                variant="ghost"
                size="lg"
                isRound={true}
                _hover={{ bg: "#0D74FF" }}
                icon={<BsGithub size="28px" />}
              />
            </Link>
  
            <Link
              id="contact-linkedin"
              href="https://www.linkedin.com/in/chinta-sivanarayana-b73806231/"
              target={"_blank"}
            >
              <IconButton
                aria-label="linkedin"
                variant="ghost"
                size="lg"
                color="#0a66c2"
                isRound={true}
                _hover={{ bg: "#0D74FF",color:"white" }}
                icon={<BsLinkedin size="28px" />
                
            }
              />
            </Link>

            <Link
              id="contact-linkedin"
              href="https://discord.com/channels/@me/1007858108778946642"
              target={"_blank"}
            >
              <IconButton
                aria-label="linkedin"
                variant="ghost"
                size="lg"
                color="#0a66c2"
                isRound={true}
                _hover={{ bg: "#0D74FF",color:"white" }}
                icon={<SiDiscord size="28px" />
                
            }
              />
            </Link>
          </HStack>
  
          <Stack
            direction={{ base: "column", md: "row" }}
            border={"0px"}
            margin={"auto"}
          >
            <Button
              id="contact-phone"
              size="md"
              height="48px"
              variant="ghost"
              color="0a9396"
              _hover={{ border: "3px solid teal" }}
              leftIcon={<MdPhone color="#1970F1" size="20px" />}
            >
              +91-6302661377
            </Button>
  
            <Button
              size="md"
              height="48px"
              // width="150px"
              variant="ghost"
              color="0a9396"
              _hover={{ border: "3px solid teal" }}
              leftIcon={<MdLocationOn color="#1970F1" size="20px" />}
            >
              Andhra Pradesh, Dharamavaram
            </Button>
  
            <Tooltip
              label={hasCopied ? "Email Copied!" : "Copy Email"}
              closeOnClick={false}
              hasArrow
            >
              <Button
                id="contact-email"
                size="md"
                height="48px"
                // width="300px"
                variant="ghost"
                color="0a9396"
                _hover={{ border: "3px solid teal" }}
                onClick={onCopy}
                leftIcon={<MdEmail color="#1970F1" size="20px" />}
              >
                chinthasiva872@gmail.com
              </Button>
            </Tooltip>
          </Stack>
        </VStack>
      </div>
    );
  };